import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import Phonecall from '../../assets/images/notificationIcons/Phonecall.png';
import EmailIcon from '../../assets/images/notificationIcons/emailIcon.png';
import WhatsappIcon from '../../assets/images/notificationIcons/WhatsappIcon.png';
import Message from '../../assets/images/notificationIcons/message.png';

const TopCards = ({ countWhatsapp, countSMS, countIVR, onCardClick }) => {
  const cards = [
    {
      label: 'Whatsapp',
      icon: WhatsappIcon,
      count: `${countWhatsapp.WhatsappSuccess}/${countWhatsapp.Whatsapp}`,
      bgColor: '#40d89f',
      type: 3,
    },
    {
      label: 'SMS',
      icon: Message,
      count: `${countSMS.SMSSuccess}/${countSMS.SMS}`,
      bgColor: '#3e7bf0',
      type: 2,
    },
    {
      label: 'OBD',
      icon: Phonecall,
      count: `${countIVR.IVRSuccess}/${countIVR.IVR}`,
      bgColor: '#7857f0',
      type: 4,
    },
    {
      label: 'Email',
      icon: EmailIcon,
      count: `${countIVR.EmailSuccess}/${countIVR.Email}`,
      bgColor: '#E74C3C',
      type: 1,
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mt: 3 }}>
      {cards.map(({ label, icon, count, bgColor, type }) => (
        <Grid item xs={12} sm={6} md={3} key={label}>
          <Card
            onClick={() => onCardClick?.(type)}
            sx={{
              backgroundColor: bgColor,
              color: '#fff',
              cursor: 'pointer',
              '&:hover': { opacity: 0.9 },
            }}
          >
            <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
              <Box component="img" src={icon} alt={`${label}-icon`} sx={{ height: 50, mr: 2 }} />
              <Box>
                <Typography variant="subtitle2">{label}</Typography>
                  <h5 style={{ margin: 0,color: "#fff" }}>{count} </h5>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default TopCards;
